<template>
    <div class=" marginL201 clearfix">
        <div class="login-title h50">
            <span></span>
            业务设置
        </div>
        <div class="clearfix set-form-wrap marginT35" v-loading="!isSuccess">
            <div class="fl w480">
                <div class="marginT20">
                    <div class="h36">
                        <label class="business-item-title">开通个人图文咨询业务</label>
                        <!--滑块-->
                        <div class="switch-wrap h36 w160 marginL70">
                            <div class="business-mask h36 w80" :class="{ 'move': !isTogglePic  }"></div>
                            <button
                                    class=" switch-btn h36 w80 fl"
                                    :class="{ 'white-color': isTogglePic }"
                                    @click="openPic">
                                开通
                            </button>
                            <button
                                    class="switch-btn h36 w80"
                                    :class="{ 'white-color': !isTogglePic }"
                                    @click="closePic">
                                不开通
                            </button>
                        </div>
                    </div>
                    <div class="clearfix marginT20">
                        <label class="fl h34 business-item-label">个人图文咨询费用</label>
                        <el-input type="number" class="form-input marginL10 marginR10 h34 w74" :disabled="!isTogglePic" :min="0" v-model.number.trim="picPrice" @blur="picBlur"></el-input>
                        <!--<input type="number" class="form-input marginL10 marginR10 h34 w74  businees-input" :disabled="!isTogglePic" v-model.number.trim="picPrice">-->
                        <label class="fl h34 business-item-label">元/次</label>
                    </div>
                    <div>
                        <p class="marginT10 gray-color fontSize14">主治医师建议费用：10-50元/次</p>
                        <p class="marginT10 gray-color fontSize14">副主任医师建议费用：30-100元/次</p>
                        <p class="marginT10 gray-color fontSize14">主任医师建议费用：80-150元/次</p>
                    </div>
                </div>
                <div class="marginT60">
                    <div class="h36">
                        <label class="business-item-title">开通个人视频问诊业务</label>
                        <!--滑块-->
                        <div class="switch-wrap h36 w160 marginL70">
                            <div class="business-mask h36 w80" :class="{ 'move': !isToggleVideo  }"></div>
                            <button
                                    class=" switch-btn h36 w80 fl"
                                    :class="{ 'white-color': isToggleVideo }"
                                    @click="openVideo">
                                开通
                            </button>
                            <button
                                    class="switch-btn h36 w80"
                                    :class="{ 'white-color': !isToggleVideo }"
                                    @click="closeVideo">
                                不开通
                            </button>
                        </div>
                    </div>
                    <div class="clearfix marginT20">
                        <label class="fl h34 business-item-label">个人视频问诊费用</label>
                        <el-input type="number" class="form-input marginL10 marginR10 h34 w74" :disabled="!isToggleVideo" :min="0" v-model.number.trim="videoPrice" @blur="picBlur"></el-input>
                        <label class="fl h34 business-item-label">元/次</label>
                    </div>
                    <div>
                        <p class="marginT10 gray-color fontSize14">副主任医师建议费用：200-1000元/次</p>
                        <p class="marginT10 gray-color fontSize14">主任医师建议费用：500-2000元/次</p>
                    </div>
                </div>

                <el-button type="primary" class="h36 w140 marginT60 save-btn" @click="businessSave" :loading="isSubmit">保存</el-button>
            </div>
        </div>
    </div>
</template>
<style>

</style>
<script>
    import axiosUtil from "../../utils/AxiosUtils.js"
    import { Message, Loading } from "element-ui";
    export default{
        data: function(){
            return{
                picPrice: 0,
                videoPrice: 0,
                isTogglePic: JSON.parse(sessionStorage.getItem("loginInfo")).docPicConsultStatus,
                isToggleVideo: JSON.parse(sessionStorage.getItem("loginInfo")).docVideoConsultStatus,
                isSubmit: false,//是否设置成功
                isSuccess: false,// 数据是否加载成功
            }
        },
        components:{
        },
        computed: {
            /*picPrice:{//图文咨询价格(表单双向绑定不能直接修改state)
                get(){
                    return this.$store.state.userInfo.docPicConsultPrice;
                },
                set(value){
                    this.$store.dispatch("setBusSettingPicPrice", value);
                }
            },
            videoPrice: {//视频问诊价格
                get(){
                    return this.$store.state.userInfo.docVideoConsultPrice;
                },
                set(value){
                    this.$store.dispatch("setBusSettingVideoPrice", value);
                }
            },
            isTogglePic: function(){//图文咨询开通与否
                return this.$store.state.userInfo.docPicConsultStatus;
            },
            isToggleVideo: function(){//视频问诊开通与否，
                return this.$store.state.userInfo.docVideoConsultStatus;

            }*/
        },
        created: function(){
           this.getDetail();
        },
        methods: {
            getDetail: function(){// 获取数据
                this.isSuccess = false;
                let _this = this;
                let options = {
                    docId: JSON.parse(sessionStorage.getItem("loginInfo")).docId,
                    token: localStorage.getItem("token"),
                    Service: "nethos.doc.detail"
                };
                axiosUtil(options, function(data){
                    _this.isSuccess = true;
                    _this.picPrice = data.obj.docPicConsultPrice;
                    _this.videoPrice = data.obj.docVideoConsultPrice;
                }, function () {
                    _this.isSuccess = true;
                });
            },
            openPic: function(){//点击开通图文咨询业务
                if(this.isTogglePic){
                    return;
                }
                //this.$store.dispatch("setBusSettingPicState", true);
                this.isTogglePic = true;
            },
            closePic: function(){//点击关闭图文咨询业务
                if(!this.isTogglePic){
                    return;
                }
                //this.$store.dispatch("setBusSettingPicState", false);
                this.isTogglePic = false;
            },
            openVideo: function(){//点击开通视频问诊业务
                if(this.isToggleVideo){
                    return;
                }
                //this.$store.dispatch("setBusSettingVideoState", true);
                this.isToggleVideo = true;
            },
            closeVideo: function(){//点击关闭视频问诊业务
                if(!this.isToggleVideo){
                    return;
                }
                //this.$store.dispatch("setBusSettingVideoState", false);
                this.isToggleVideo = false;
            },
            businessSave: function(){//点击保持业务设置
                let _this = this;
                this.isSubmit = true;
                let options = {
                    docId: JSON.parse(sessionStorage.getItem("loginInfo")).docId,
                    docVideoConsultStatus: _this.isToggleVideo,
                    docVideoConsultPrice: _this.videoPrice,
                    docPicConsultStatus: _this.isTogglePic,
                    docPicConsultPrice: _this.picPrice,
                    token: localStorage.getItem("token"),
                    Service: "nethos.doc.service.setup",
                };
                axiosUtil(options, function(data){
                    _this.isSubmit = false;
                    let userInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
                    userInfo.docVideoConsultStatus = _this.isToggleVideo;
                    userInfo.docVideoConsultPrice = _this.videoPrice;
                    userInfo.docPicConsultStatus = _this.isTogglePic;
                    userInfo.docPicConsultPrice = _this.picPrice;
                    localStorage.setItem("userInfo", JSON.stringify(userInfo));
                    Message({
                       showClose: true,
                       message: "保存成功！",
                       type: "success"
                    });
                }, function () {
                    _this.isSubmit = false;
                });
            },
            picBlur: function(e){// 图文视频费用输入框失去焦点事件
                /*if(value.indexOf('.')!==-1){// 保留整数
                    e.target.value = value.slice(0,  value.indexOf('.'));
                }*/
                if(e.target.value < 0){
                    e.target.value = 0;
                }else {
                    e.target.value = parseFloat(parseFloat(e.target.value).toFixed(2));
                }
            },
        }
    }
</script>
